// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__9fCZN","detail-item":"styles_detail-item__vtJo_"};